// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _postV1Permission = async (url: string, request: Types.PostV1PermissionRequest): Promise<Types.PostV1PermissionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/permission/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Permission: Api['postV1Permission'] = async (request: Types.PostV1PermissionRequest): Promise<Types.PostV1PermissionResponses> => {
  return await _postV1Permission(baseUrl, request)
}
const _getV1Permission = async (url: string, request: Types.GetV1PermissionRequest): Promise<Types.GetV1PermissionResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/permission/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Permission: Api['getV1Permission'] = async (request: Types.GetV1PermissionRequest): Promise<Types.GetV1PermissionResponses> => {
  return await _getV1Permission(baseUrl, request)
}
const _getV1PermissionId = async (url: string, request: Types.GetV1PermissionIdRequest): Promise<Types.GetV1PermissionIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/permission/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PermissionId: Api['getV1PermissionId'] = async (request: Types.GetV1PermissionIdRequest): Promise<Types.GetV1PermissionIdResponses> => {
  return await _getV1PermissionId(baseUrl, request)
}
const _putV1PermissionId = async (url: string, request: Types.PutV1PermissionIdRequest): Promise<Types.PutV1PermissionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/permission/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PermissionId: Api['putV1PermissionId'] = async (request: Types.PutV1PermissionIdRequest): Promise<Types.PutV1PermissionIdResponses> => {
  return await _putV1PermissionId(baseUrl, request)
}
const _deleteV1PermissionId = async (url: string, request: Types.DeleteV1PermissionIdRequest): Promise<Types.DeleteV1PermissionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/permission/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PermissionId: Api['deleteV1PermissionId'] = async (request: Types.DeleteV1PermissionIdRequest): Promise<Types.DeleteV1PermissionIdResponses> => {
  return await _deleteV1PermissionId(baseUrl, request)
}
const _getV1PermissionRoleId = async (url: string, request: Types.GetV1PermissionRoleIdRequest): Promise<Types.GetV1PermissionRoleIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/permission/role/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PermissionRoleId: Api['getV1PermissionRoleId'] = async (request: Types.GetV1PermissionRoleIdRequest): Promise<Types.GetV1PermissionRoleIdResponses> => {
  return await _getV1PermissionRoleId(baseUrl, request)
}
const _postV1Resource = async (url: string, request: Types.PostV1ResourceRequest): Promise<Types.PostV1ResourceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Resource: Api['postV1Resource'] = async (request: Types.PostV1ResourceRequest): Promise<Types.PostV1ResourceResponses> => {
  return await _postV1Resource(baseUrl, request)
}
const _getV1Resource = async (url: string, request: Types.GetV1ResourceRequest): Promise<Types.GetV1ResourceResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Resource: Api['getV1Resource'] = async (request: Types.GetV1ResourceRequest): Promise<Types.GetV1ResourceResponses> => {
  return await _getV1Resource(baseUrl, request)
}
const _getV1ResourceId = async (url: string, request: Types.GetV1ResourceIdRequest): Promise<Types.GetV1ResourceIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceId: Api['getV1ResourceId'] = async (request: Types.GetV1ResourceIdRequest): Promise<Types.GetV1ResourceIdResponses> => {
  return await _getV1ResourceId(baseUrl, request)
}
const _putV1ResourceId = async (url: string, request: Types.PutV1ResourceIdRequest): Promise<Types.PutV1ResourceIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ResourceId: Api['putV1ResourceId'] = async (request: Types.PutV1ResourceIdRequest): Promise<Types.PutV1ResourceIdResponses> => {
  return await _putV1ResourceId(baseUrl, request)
}
const _deleteV1ResourceId = async (url: string, request: Types.DeleteV1ResourceIdRequest): Promise<Types.DeleteV1ResourceIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ResourceId: Api['deleteV1ResourceId'] = async (request: Types.DeleteV1ResourceIdRequest): Promise<Types.DeleteV1ResourceIdResponses> => {
  return await _deleteV1ResourceId(baseUrl, request)
}
const _getV1ResourceModules = async (url: string, request: Types.GetV1ResourceModulesRequest): Promise<Types.GetV1ResourceModulesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/modules`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ResourceModules: Api['getV1ResourceModules'] = async (request: Types.GetV1ResourceModulesRequest): Promise<Types.GetV1ResourceModulesResponses> => {
  return await _getV1ResourceModules(baseUrl, request)
}
const _postV1ResourceSubModules = async (url: string, request: Types.PostV1ResourceSubModulesRequest): Promise<Types.PostV1ResourceSubModulesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/resource/sub-modules`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ResourceSubModules: Api['postV1ResourceSubModules'] = async (request: Types.PostV1ResourceSubModulesRequest): Promise<Types.PostV1ResourceSubModulesResponses> => {
  return await _postV1ResourceSubModules(baseUrl, request)
}
const _postV1Role = async (url: string, request: Types.PostV1RoleRequest): Promise<Types.PostV1RoleResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Role: Api['postV1Role'] = async (request: Types.PostV1RoleRequest): Promise<Types.PostV1RoleResponses> => {
  return await _postV1Role(baseUrl, request)
}
const _getV1Role = async (url: string, request: Types.GetV1RoleRequest): Promise<Types.GetV1RoleResponses> => {
  const queryParameters: (keyof Types.GetV1RoleRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Role: Api['getV1Role'] = async (request: Types.GetV1RoleRequest): Promise<Types.GetV1RoleResponses> => {
  return await _getV1Role(baseUrl, request)
}
const _getV1RoleId = async (url: string, request: Types.GetV1RoleIdRequest): Promise<Types.GetV1RoleIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoleId: Api['getV1RoleId'] = async (request: Types.GetV1RoleIdRequest): Promise<Types.GetV1RoleIdResponses> => {
  return await _getV1RoleId(baseUrl, request)
}
const _putV1RoleId = async (url: string, request: Types.PutV1RoleIdRequest): Promise<Types.PutV1RoleIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RoleId: Api['putV1RoleId'] = async (request: Types.PutV1RoleIdRequest): Promise<Types.PutV1RoleIdResponses> => {
  return await _putV1RoleId(baseUrl, request)
}
const _deleteV1RoleId = async (url: string, request: Types.DeleteV1RoleIdRequest): Promise<Types.DeleteV1RoleIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RoleId: Api['deleteV1RoleId'] = async (request: Types.DeleteV1RoleIdRequest): Promise<Types.DeleteV1RoleIdResponses> => {
  return await _deleteV1RoleId(baseUrl, request)
}
const _getV1RoleUserId = async (url: string, request: Types.GetV1RoleUserIdRequest): Promise<Types.GetV1RoleUserIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/user/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoleUserId: Api['getV1RoleUserId'] = async (request: Types.GetV1RoleUserIdRequest): Promise<Types.GetV1RoleUserIdResponses> => {
  return await _getV1RoleUserId(baseUrl, request)
}
const _postV1RoleUserId = async (url: string, request: Types.PostV1RoleUserIdRequest): Promise<Types.PostV1RoleUserIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/role/user/${request['id']}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RoleUserId: Api['postV1RoleUserId'] = async (request: Types.PostV1RoleUserIdRequest): Promise<Types.PostV1RoleUserIdResponses> => {
  return await _postV1RoleUserId(baseUrl, request)
}
const _postV1User = async (url: string, request: Types.PostV1UserRequest): Promise<Types.PostV1UserResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1User: Api['postV1User'] = async (request: Types.PostV1UserRequest): Promise<Types.PostV1UserResponses> => {
  return await _postV1User(baseUrl, request)
}
const _getV1User = async (url: string, request: Types.GetV1UserRequest): Promise<Types.GetV1UserResponses> => {
  const queryParameters: (keyof Types.GetV1UserRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1User: Api['getV1User'] = async (request: Types.GetV1UserRequest): Promise<Types.GetV1UserResponses> => {
  return await _getV1User(baseUrl, request)
}
const _getV1UserBranch = async (url: string, request: Types.GetV1UserBranchRequest): Promise<Types.GetV1UserBranchResponses> => {
  const queryParameters: (keyof Types.GetV1UserBranchRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/branch?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UserBranch: Api['getV1UserBranch'] = async (request: Types.GetV1UserBranchRequest): Promise<Types.GetV1UserBranchResponses> => {
  return await _getV1UserBranch(baseUrl, request)
}
const _getV1UserLocation = async (url: string, request: Types.GetV1UserLocationRequest): Promise<Types.GetV1UserLocationResponses> => {
  const queryParameters: (keyof Types.GetV1UserLocationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/location?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UserLocation: Api['getV1UserLocation'] = async (request: Types.GetV1UserLocationRequest): Promise<Types.GetV1UserLocationResponses> => {
  return await _getV1UserLocation(baseUrl, request)
}
const _getV1UserDepartment = async (url: string, request: Types.GetV1UserDepartmentRequest): Promise<Types.GetV1UserDepartmentResponses> => {
  const queryParameters: (keyof Types.GetV1UserDepartmentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/department?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UserDepartment: Api['getV1UserDepartment'] = async (request: Types.GetV1UserDepartmentRequest): Promise<Types.GetV1UserDepartmentResponses> => {
  return await _getV1UserDepartment(baseUrl, request)
}
const _getV1UserId = async (url: string, request: Types.GetV1UserIdRequest): Promise<Types.GetV1UserIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UserId: Api['getV1UserId'] = async (request: Types.GetV1UserIdRequest): Promise<Types.GetV1UserIdResponses> => {
  return await _getV1UserId(baseUrl, request)
}
const _putV1UserId = async (url: string, request: Types.PutV1UserIdRequest): Promise<Types.PutV1UserIdResponses> => {
  const queryParameters: (keyof Types.PutV1UserIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/${request['id']}?${searchParams.toString()}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1UserId: Api['putV1UserId'] = async (request: Types.PutV1UserIdRequest): Promise<Types.PutV1UserIdResponses> => {
  return await _putV1UserId(baseUrl, request)
}
const _deleteV1UserId = async (url: string, request: Types.DeleteV1UserIdRequest): Promise<Types.DeleteV1UserIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1UserId: Api['deleteV1UserId'] = async (request: Types.DeleteV1UserIdRequest): Promise<Types.DeleteV1UserIdResponses> => {
  return await _deleteV1UserId(baseUrl, request)
}
const _patchV1UserUpdateStatusId = async (url: string, request: Types.PatchV1UserUpdateStatusIdRequest): Promise<Types.PatchV1UserUpdateStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/update-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1UserUpdateStatusId: Api['patchV1UserUpdateStatusId'] = async (request: Types.PatchV1UserUpdateStatusIdRequest): Promise<Types.PatchV1UserUpdateStatusIdResponses> => {
  return await _patchV1UserUpdateStatusId(baseUrl, request)
}
const _getV1UserModules = async (url: string, request: Types.GetV1UserModulesRequest): Promise<Types.GetV1UserModulesResponses> => {
  const queryParameters: (keyof Types.GetV1UserModulesRequest)[]  = ['module']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user/modules?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UserModules: Api['getV1UserModules'] = async (request: Types.GetV1UserModulesRequest): Promise<Types.GetV1UserModulesResponses> => {
  return await _getV1UserModules(baseUrl, request)
}

const _postV1AuthLogin = async (url: string, request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/auth/login`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AuthLogin: Api['postV1AuthLogin'] = async (request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  return await _postV1AuthLogin(baseUrl, request)
}
const _postV1Company = async (url: string, request: Types.PostV1CompanyRequest): Promise<Types.PostV1CompanyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Company: Api['postV1Company'] = async (request: Types.PostV1CompanyRequest): Promise<Types.PostV1CompanyResponses> => {
  return await _postV1Company(baseUrl, request)
}
const _getV1Company = async (url: string, request: Types.GetV1CompanyRequest): Promise<Types.GetV1CompanyResponses> => {
  const queryParameters: (keyof Types.GetV1CompanyRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Company: Api['getV1Company'] = async (request: Types.GetV1CompanyRequest): Promise<Types.GetV1CompanyResponses> => {
  return await _getV1Company(baseUrl, request)
}
const _getV1CompanyId = async (url: string, request: Types.GetV1CompanyIdRequest): Promise<Types.GetV1CompanyIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CompanyId: Api['getV1CompanyId'] = async (request: Types.GetV1CompanyIdRequest): Promise<Types.GetV1CompanyIdResponses> => {
  return await _getV1CompanyId(baseUrl, request)
}
const _putV1CompanyId = async (url: string, request: Types.PutV1CompanyIdRequest): Promise<Types.PutV1CompanyIdResponses> => {
  const queryParameters: (keyof Types.PutV1CompanyIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company/${request['id']}?${searchParams.toString()}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CompanyId: Api['putV1CompanyId'] = async (request: Types.PutV1CompanyIdRequest): Promise<Types.PutV1CompanyIdResponses> => {
  return await _putV1CompanyId(baseUrl, request)
}
const _deleteV1CompanyId = async (url: string, request: Types.DeleteV1CompanyIdRequest): Promise<Types.DeleteV1CompanyIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/company/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CompanyId: Api['deleteV1CompanyId'] = async (request: Types.DeleteV1CompanyIdRequest): Promise<Types.DeleteV1CompanyIdResponses> => {
  return await _deleteV1CompanyId(baseUrl, request)
}
const _postV1Config = async (url: string, request: Types.PostV1ConfigRequest): Promise<Types.PostV1ConfigResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/config/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Config: Api['postV1Config'] = async (request: Types.PostV1ConfigRequest): Promise<Types.PostV1ConfigResponses> => {
  return await _postV1Config(baseUrl, request)
}
const _getV1Config = async (url: string, request: Types.GetV1ConfigRequest): Promise<Types.GetV1ConfigResponses> => {
  const queryParameters: (keyof Types.GetV1ConfigRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/config/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Config: Api['getV1Config'] = async (request: Types.GetV1ConfigRequest): Promise<Types.GetV1ConfigResponses> => {
  return await _getV1Config(baseUrl, request)
}
const _getV1ConfigId = async (url: string, request: Types.GetV1ConfigIdRequest): Promise<Types.GetV1ConfigIdResponses> => {
  const queryParameters: (keyof Types.GetV1ConfigIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/config/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ConfigId: Api['getV1ConfigId'] = async (request: Types.GetV1ConfigIdRequest): Promise<Types.GetV1ConfigIdResponses> => {
  return await _getV1ConfigId(baseUrl, request)
}
const _putV1ConfigId = async (url: string, request: Types.PutV1ConfigIdRequest): Promise<Types.PutV1ConfigIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/config/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ConfigId: Api['putV1ConfigId'] = async (request: Types.PutV1ConfigIdRequest): Promise<Types.PutV1ConfigIdResponses> => {
  return await _putV1ConfigId(baseUrl, request)
}
const _deleteV1ConfigId = async (url: string, request: Types.DeleteV1ConfigIdRequest): Promise<Types.DeleteV1ConfigIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/config/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ConfigId: Api['deleteV1ConfigId'] = async (request: Types.DeleteV1ConfigIdRequest): Promise<Types.DeleteV1ConfigIdResponses> => {
  return await _deleteV1ConfigId(baseUrl, request)
}
const _getV1LocationsCountries = async (url: string, request: Types.GetV1LocationsCountriesRequest): Promise<Types.GetV1LocationsCountriesResponses> => {
  const queryParameters: (keyof Types.GetV1LocationsCountriesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }

  const response = await fetch(`${url}/v1/locations/countries?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LocationsCountries: Api['getV1LocationsCountries'] = async (request: Types.GetV1LocationsCountriesRequest): Promise<Types.GetV1LocationsCountriesResponses> => {
  return await _getV1LocationsCountries(baseUrl, request)
}
const _getV1LocationsStates = async (url: string, request: Types.GetV1LocationsStatesRequest): Promise<Types.GetV1LocationsStatesResponses> => {
  const queryParameters: (keyof Types.GetV1LocationsStatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }

  const response = await fetch(`${url}/v1/locations/states?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LocationsStates: Api['getV1LocationsStates'] = async (request: Types.GetV1LocationsStatesRequest): Promise<Types.GetV1LocationsStatesResponses> => {
  return await _getV1LocationsStates(baseUrl, request)
}

const _postV1AuthForgotPassword = async (url: string, request: Types.PostV1AuthForgotPasswordRequest): Promise<Types.PostV1AuthLoginResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  const response = await fetch(`${url}/v1/auth/forgot-password`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  });

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return  await response.json()
}

// Reset password
export const postV1AuthForgotPassword: Api['postV1AuthLogin'] = async (request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  return await _postV1AuthForgotPassword(baseUrl, request)
}

const _postV1AuthResetPassword = async (url: string, request: Types.PostV1AuthForgotPasswordRequest): Promise<Types.PostV1AuthLoginResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }


  const response = await fetch(`${url}/v1/auth/reset-password?token=${request?.token}`, {
    method: "GET"
  });

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AuthResetPassword: Api['postV1AuthLogin'] = async (request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  return await _postV1AuthResetPassword(baseUrl, request)
}

// change password

const _postV1AuthChangePassword = async (url: string, request: Types.PostV1AuthForgotPasswordRequest): Promise<Types.PostV1AuthLoginResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  
  let obj = {
    password: request.password,
    token: request.token
  }

  const response = await fetch(`${url}/v1/auth/change-password`, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers
  });

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1AuthChangePassword: Api['postV1AuthLogin'] = async (request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  return await _postV1AuthChangePassword(baseUrl, request)
}

// change user password
const _postV1AuthChangeUserPassword = async (url: string, request: Types.PostV1AuthForgotPasswordRequest): Promise<Types.PostV1AuthLoginResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8',
    'x-token': request['x-token']
  }


  let obj = {
    current_password: request.current_password,
    password: request.password,
  }


  const response = await fetch(`${url}/v1/auth/change-user-password`, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers
  });

  if (!response.ok) {  
    throw new Error(await response.text())
  }

  let finalResponse = await response.json();
  return finalResponse;
}



export const postV1AuthChangeUserPassword: Api['postV1AuthLogin'] = async (request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  return await _postV1AuthChangeUserPassword(baseUrl, request)
}

export const postV1AuthChangeUserPasswordByAdmin: Api['postV1AuthLogin'] = async (request: Types.PostV1AuthLoginRequest): Promise<Types.PostV1AuthLoginResponses> => {
  return await _postV1AuthChangeUserPasswordByAdmin(baseUrl, request)
}

const _postV1AuthChangeUserPasswordByAdmin = async (url: string, request: Types.PostV1AuthForgotPasswordRequest): Promise<Types.PostV1AuthLoginResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8',
    'x-token': request['x-token']
  }


  let obj = {
    id: request.id,
    password: request.password,
    isNotify: request.isNotify
  }

  const response = await fetch(`${url}/v1/auth/change-user-password-by-admin`, {
    method: 'POST',
    body: JSON.stringify(obj),
    headers
  });

  if (!response.ok) {  
    throw new Error(await response.text())
  }

  let finalResponse = await response.json();
  return finalResponse;
}

type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    postV1Permission: _postV1Permission.bind(url, ...arguments),
    getV1Permission: _getV1Permission.bind(url, ...arguments),
    getV1PermissionId: _getV1PermissionId.bind(url, ...arguments),
    putV1PermissionId: _putV1PermissionId.bind(url, ...arguments),
    deleteV1PermissionId: _deleteV1PermissionId.bind(url, ...arguments),
    getV1PermissionRoleId: _getV1PermissionRoleId.bind(url, ...arguments),
    postV1Resource: _postV1Resource.bind(url, ...arguments),
    getV1Resource: _getV1Resource.bind(url, ...arguments),
    getV1ResourceId: _getV1ResourceId.bind(url, ...arguments),
    putV1ResourceId: _putV1ResourceId.bind(url, ...arguments),
    deleteV1ResourceId: _deleteV1ResourceId.bind(url, ...arguments),
    getV1ResourceModules: _getV1ResourceModules.bind(url, ...arguments),
    postV1ResourceSubModules: _postV1ResourceSubModules.bind(url, ...arguments),
    postV1Role: _postV1Role.bind(url, ...arguments),
    getV1Role: _getV1Role.bind(url, ...arguments),
    getV1RoleId: _getV1RoleId.bind(url, ...arguments),
    putV1RoleId: _putV1RoleId.bind(url, ...arguments),
    deleteV1RoleId: _deleteV1RoleId.bind(url, ...arguments),
    getV1RoleUserId: _getV1RoleUserId.bind(url, ...arguments),
    postV1RoleUserId: _postV1RoleUserId.bind(url, ...arguments),
    postV1User: _postV1User.bind(url, ...arguments),
    getV1User: _getV1User.bind(url, ...arguments),
    getV1UserBranch: _getV1UserBranch.bind(url, ...arguments),
    getV1UserLocation: _getV1UserLocation.bind(url, ...arguments),
    getV1UserDepartment: _getV1UserDepartment.bind(url, ...arguments),
    getV1UserId: _getV1UserId.bind(url, ...arguments),
    putV1UserId: _putV1UserId.bind(url, ...arguments),
    deleteV1UserId: _deleteV1UserId.bind(url, ...arguments),
    patchV1UserUpdateStatusId: _patchV1UserUpdateStatusId.bind(url, ...arguments),
    getV1UserModules: _getV1UserModules.bind(url, ...arguments),
    postV1AuthLogin: _postV1AuthLogin.bind(url, ...arguments),
    postV1Company: _postV1Company.bind(url, ...arguments),
    getV1Company: _getV1Company.bind(url, ...arguments),
    getV1CompanyId: _getV1CompanyId.bind(url, ...arguments),
    putV1CompanyId: _putV1CompanyId.bind(url, ...arguments),
    deleteV1CompanyId: _deleteV1CompanyId.bind(url, ...arguments),
    postV1Config: _postV1Config.bind(url, ...arguments),
    getV1Config: _getV1Config.bind(url, ...arguments),
    getV1ConfigId: _getV1ConfigId.bind(url, ...arguments),
    putV1ConfigId: _putV1ConfigId.bind(url, ...arguments),
    deleteV1ConfigId: _deleteV1ConfigId.bind(url, ...arguments),
    getV1LocationsCountries: _getV1LocationsCountries.bind(url, ...arguments),
    getV1LocationsStates: _getV1LocationsStates.bind(url, ...arguments)
  }
}